export default "__VITE_ASSET__BHfbJUHb__"